/**
 * Privé Brain OCR helpers — browser IIFE
 *
 * Normalizes raw Tesseract output and decides whether it's strong enough
 * to feed the text-search endpoint instead of falling through to Gemini
 * vision. Mirrors the server-side logic in lib/prive-utils.js so the
 * same stop list and gate thresholds apply everywhere.
 *
 * Exposes:
 *   window.PriveBrainOcr.normalizeOcr(raw) -> { text, tokens }
 *   window.PriveBrainOcr.isUsableOcr(tokens) -> boolean
 */
(function() {
  'use strict';

  var STOP_WORDS = {
    ml: 1, oz: 1, fl: 1, eau: 1, de: 1, parfum: 1, toilette: 1, cologne: 1,
    spray: 1, vaporisateur: 1, natural: 1, pour: 1, homme: 1, femme: 1,
    men: 1, women: 1, the: 1, and: 1, for: 1, edp: 1, edt: 1, edc: 1,
    net: 1, wt: 1, liq: 1, liqu: 1
  };

  function normalizeOcr(raw) {
    if (!raw) return { text: '', tokens: [] };
    var cleaned = String(raw).toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    var tokens = cleaned.split(' ').filter(function(t) {
      return t.length >= 3 && !STOP_WORDS[t] && !/^\d+$/.test(t);
    });
    return { text: tokens.join(' '), tokens: tokens };
  }

  function isUsableOcr(tokens) {
    if (!tokens || tokens.length === 0) return false;
    var substantive = tokens.filter(function(t) { return t.length >= 4; });
    return substantive.length >= 2;
  }

  window.PriveBrainOcr = { normalizeOcr: normalizeOcr, isUsableOcr: isUsableOcr };
})();
